import styled from 'styled-components';
import { breakpoints } from 'config/config';
import { Form } from 'antd';

export const StyledLoginForm = styled(Form)`
  display: flex;
  min-height: 545px;
  background-color: ${(props) => props.theme.white};
  font-family: ${(props) => props.theme.fontText};
  border-radius: 6px;
  width: 100%;
  max-width: 640px;

  .accept_terms {
    display: flex;
    align-items: center;
    gap: 5px;

    .link {
      font-size: 14px;
      line-height: 20px;
      color: ${(props) => props.theme.darkGrayishBlue};
    }
  }

  .login-title {
    font-size: 34px;
    color: ${(props) => props.theme.brand01};
  }

  .ant-form-item {
    margin-bottom: 5px;

    .ant-form-item-control-input-content {
      input {
        height: 55px;
      }
    }

    .ant-input-suffix {
      height: 55px;
    }
  }

  .accept_terms .ant-form-item {
    margin-bottom: 0;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    padding: 40px 70px 33px 70px;
    max-width: 640px;
    width: 640px;

    .register-mobile-header {
      display: none;
    }

    .registration-title-wrapper.reset-pw {
      margin-bottom: 0;
      .title {
        margin-bottom: 18%;
      }
      .description {
        color: ${(props) => props.theme.black};
        font-weight: 500;
      }
    }
    .registration-title-wrapper {
      margin-bottom: 17px;
      .title {
        font-weight: 600;
        font-size: 32px;
        margin-bottom: 9px;
        color: ${(props) => props.theme.darkGrayishBlue};
      }

      .description {
        margin: 0;
        font-size: 16px;
        line-height: 30px;
        color: ${(props) => props.theme.darkGrayishBlue};
      }
    }

    .registration-input-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 10px;

      .fulname {
        display: flex;
        gap: 15px;
        justify-content: space-between;

        div {
          width: 100%;
        }
      }

      .ant-input::placeholder {
        color: ${(props) => props.theme.grayishBlue};
      }

      @media only screen and (max-width: ${breakpoints.lg}px) {
        width: 100%;
      }

      .ant-input-affix-wrapper {
        padding: 0 11px;
      }

      .ant-checkbox-wrapper,
      .label {
        color: ${(props) => props.theme.darkGrayishBlue};
        font-size: 14px;
      }

      .email,
      .pw {
        font-size: 14px;
        line-height: 22px;
      }

      .pw-wrap {
        display: flex;
        flex-direction: column;
        gap: 15px;

        .pw-first,
        .pw-scnd {
          width: 100%;
        }
      }
    }

    .reset-password {
      display: flex;
      justify-content: center;
      margin-top: 15px;
      font-size: 14px;
      color: ${(props) => props.theme.black};
      text-decoration: underline;
      text-align: center;

      .text {
        min-width: 25%;
        cursor: pointer;
      }
    }

    .registration-button-wrapper {
      display: flex;
      flex-direction: column;

      &.border-wrapper {
        border: 1px solid ${(props) => props.theme.brand01};
        border-radius: 5px;
        padding: 16px;
        margin-bottom: 16px;
      }

      .cancel-back-to-landing-page {
        min-width: 241px;
        min-height: 55px;
        border: 1px solid ${(props) => props.theme.brand01};
        border-radius: 5px;
        margin-top: 10px;
      }

      .registration-buttons {
        display: flex;
        flex-direction: column;

        .ant-flex {
          .ant-btn {
            flex-grow: 1;
          }
        }
      }

      .cstm-btn {
        margin-top: 10px;
        border-radius: 5px;
        height: 55px;
      }

      .submit {
        font-weight: 600;
        margin-top: 15px;
      }

      .google {
        border-color: ${(props) => props.theme.brand01};
        background-color: transparent;
        color: ${(props) => props.theme.brand01};
      }
    }
    .no-acc-reg {
      margin-top: 13px;
      color: ${(props) => props.theme.dustyBlue};
      font-size: 14px;
      line-height: 22px;
      text-align: center;

      .login_link {
        display: inline-block;
        height: 16px;
        margin-left: 5px;
        color: ${(props) => props.theme.vividBlue};
        font-weight: 600;
        border-bottom: 1px solid ${(props) => props.theme.vividBlue};
      }
    }

    .register-login-redirect {
      font-size: 0.875rem;
      margin-bottom: 1rem;
      a {
        font-size: 0.875rem;
      }
    }

    .home-button-wrapper {
      display: flex;
      align-items: flex-end;
      height: 100%;
      button {
        color: ${(props) => props.theme.black};
        &:hover,
        &:focus,
        &:active {
          color: ${(props) => props.theme.black};
        }
        .text {
          color: ${(props) => props.theme.black};
          font-size: 18px;
          font-weight: 500;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    width: 100%;
    max-width: 100%;

    .accept_terms {
      .link {
        font-size: 0.875rem;
      }
    }

    .login-title {
      font-size: 2rem;
      text-align: center;
    }

    .inputs {
      max-width: 100%;
      width: 100%;
      padding: 40px;

      .register-mobile-header {
        display: flex;
        flex-direction: column;
        align-items: center;

        .register-title {
          align-self: center;
          font-size: 2rem;
          font-weight: 600;
          margin: 7px 0;
        }

        .register-description {
          font-size: 1rem;
        }
      }

      .registration-title-wrapper {
        .title {
          font-size: 2rem;
        }

        .description {
          font-size: 1rem;
        }
      }

      .registration-buttons {
        .ant-flex {
          flex-direction: column;

          .ant-btn {
            img {
              height: 24px;
            }
          }
        }
      }

      .registration-input-wrapper {
        .ant-checkbox-wrapper,
        .label {
          font-size: 0.875rem;
        }

        .email,
        .pw {
          font-size: 0.875rem;
        }
        .pw-wrap {
          .pw-first {
            width: 100%;
          }

          .pw-scnd {
            width: 100%;
          }
        }
      }

      .reset-password {
        font-size: 0.875rem;
      }

      .no-acc-reg {
        font-size: 0.875rem;
      }

      .register-login-redirect {
        font-size: 0.85rem;
      }
    }
  }

  @media only screen and (max-width: 1100px) {
    margin-right: 0;
    .inputs {
      .registration-button-wrapper {
        justify-content: flex-start;
        flex-direction: column-reverse;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .inputs {
      padding: 34px 20px 20px 20px;
      .registration-title-wrapper {
        .title {
          text-align: center;
        }
        .description {
          text-align: center;
        }
      }

      .registration-button-wrapper {
        .no-acc-reg {
          margin-bottom: 22px;
        }
      }
    }
  }
`;

export const StyledCustomButtons = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.loginCustomButtonBackground};
  border-radius: 3px;
  margin: 20px 0;

  .custom-button {
    display: flex;
    flex-grow: 1;
    height: 44px;
    cursor: pointer;

    border-radius: 3px;
    margin: 3px;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 16px;

    &.active {
      background-color: ${(props) => props.theme.white};
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .custom-button {
      font-size: 1rem;
    }
  }
`;
